var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"right_menu"},[_c('div',{staticClass:"web"},[_c('button',{on:{"click":_vm.getCudaStatus}},[_vm._v("测试按钮")]),_c('button',{on:{"click":_vm.changeCudaStatus}},[_vm._v("改变状态")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }